export interface PartnershipFormData {
  name: string;
  email: string;
  message: string;
  company: string;
  partnershipType: string;
}

export const partnershipFormService = async (
  data: PartnershipFormData
): Promise<void> => {
  try {
    const message =
      `Partnership Type: ${data.partnershipType}\n` +
      `Company: ${data.company}\n\n` +
      `Message:\n${data.message}`;

    const response = await fetch("https://api.eternity.ac/contact/meetmy-bot", {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: data.name,
        email: data.email,
        message: message,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error) {
    throw new Error(`Failed to send email: ${(error as Error).message}`);
  }
};
